<template>
  <div class="Dlxkz">
    <DLXKZ />
  </div>
</template>
<script>
import DLXKZ from "@/components/DLXKZ.vue";
export default {
  components: { DLXKZ },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Dlxkz {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>